export default "__VITE_ASSET__BulD6nHe__"